// La fecha y la hora de una reserva ("YYYY-MM-DD" y "HH:MM") son las de un reloj de México, sin zona. Aquí se comparan con las mismas
// reglas que el servidor (server/utils/horaMexico.js), sin importar la zona horaria del dispositivo:
//  - ¿Qué día es hoy? → el de Tijuana, la hora más tardía del país (el servidor vence, cierra y deja completar con ese día).
//  - ¿Cuántas horas faltan para la cita? → leyendo la cita en la hora del centro (el servidor cancela y deja reportar con esas horas).
// Para el día que se eligió en el calendario va fechaLocal: toISOString() da el día en UTC, que en México ya es mañana desde las 6 p. m.
const lector = (timeZone) => {
  const formato = new Intl.DateTimeFormat('en-US', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  });
  return (instante) => Object.fromEntries(formato.formatToParts(instante).map((p) => [p.type, p.value]));
};
const TIJUANA = lector('America/Tijuana');
const CENTRO = lector('America/Mexico_City');
const dos = (n) => String(n).padStart(2, '0');

// "YYYY-MM-DD" de una fecha en el día del dispositivo (el que se ve en el calendario)
export const fechaLocal = (d = new Date()) => `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}`;

// "YYYY-MM-DD" de hoy en México
export const hoyEnMexico = () => {
  const p = TIJUANA(new Date());
  return `${p.year}-${p.month}-${p.day}`;
};

// Instante (ms) en que empieza una cita, con su fecha y hora leídas en la hora del centro
export const instanteDeCita = (fecha, hora) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha || '') || !/^\d{2}:\d{2}$/.test(hora || '')) return NaN;
  const comoUTC = Date.parse(`${fecha}T${hora}:00Z`);
  if (Number.isNaN(comoUTC)) return NaN;
  const p = CENTRO(comoUTC);
  const desfase = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute) - comoUTC;   // la hora del centro menos la UTC (−6 h)
  return comoUTC - desfase;
};
